export { default } from './ImageSingleChoiceText.js';
